import { createSlice } from "@reduxjs/toolkit";
import getCommonGeneralSettings from "@custom/rtk-apis/billing/getCommonGeneralSettings";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getCommonGeneralSettingsSlice = createSlice({
  name: "getCommonGeneralSettingsSlice",
  initialState,
  reducers: {
    clearGeneralSettings: (state: any) => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCommonGeneralSettings.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCommonGeneralSettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(getCommonGeneralSettings.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getCommonGeneralSettingsSlice.reducer;
export const { clearGeneralSettings } = getCommonGeneralSettingsSlice.actions;
